import React, { useState } from "react";

export default function PastMeasurement({ data = [], type }) {

    const [visibleCount, setVisibleCount] = useState(10);

    const getValue = (item) => {
        if (type === "wt") return `${parseFloat(Number(item.weight).toFixed(1))} kg`;
        if (type === "ht") return `${parseFloat(Number(item.height).toFixed(1))} cm`;
        if (type === "hc") return `${parseFloat(Number(item.hc).toFixed(1))} cm`;
    };

    const getRange = (item) => {
        if (type === "wt") return `${item.idealminwt} - ${item.idealmaxwt} kg`;
        if (type === "ht") return `${item.idealminht} - ${item.idealmaxht} cm`;
        if (type === "hc") return `${item.idealminhc} - ${item.idealmaxhc} cm`;
    };

    const getLabel = () => {
        if (type === "wt") return "WEIGHT";
        if (type === "ht") return "HEIGHT";
        if (type === "hc") return "HEAD CIRC";
    };

    const sortedData = data
        .slice()
        .sort((a, b) => b.date - a.date);

    const visibleData = sortedData.slice(0, visibleCount);

    return (
        <div className="past-Measurements-div">

            <div className="past-Measurements-title">
                Past Measurements
            </div>

            <table className="past-Measurements-tbl">
                <thead>
                    <tr>
                        <td className="tbl-head">DATE</td>
                        <td className="tbl-head">AGE</td>
                        <td className="tbl-head">{getLabel()}</td>
                        <td className="tbl-head">WHO RANGE</td>
                    </tr>
                </thead>

                <tbody>
                    {visibleData.length > 0 ? (
                        visibleData.map((item, index) => {

                            const date = new Date(
                                item.date * 1000
                            ).toLocaleDateString("en-GB", {
                                day: "numeric",
                                month: "short",
                                year: "2-digit"
                            });

                            return (
                                <tr key={index}>
                                    <td className="tbl-row">{date}</td>
                                    <td className="tbl-row">{item.age}</td>
                                    <td className="tbl-row">{getValue(item)}</td>
                                    <td className="tbl-row">{getRange(item)}</td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="4">No data available</td>
                        </tr>
                    )}
                </tbody>
            </table>

            {visibleCount < sortedData.length && (
                <div className="load-more-wrapper">
                    <span className="load-more-btn" onClick={() => setVisibleCount(prev => prev + 10)} >
                        Load More
                    </span>
                </div>
            )}
        </div>
    );
}

